'use client'

import MainNav from '@/app/components/MainNav'
import DeploymentSavings from '@/app/components/calculators/DeploymentSavings'

export default function DeploymentSavingsPage() {
  return (
    <div className="space-y-8 pb-16">
      <MainNav />
      <div className="mx-auto max-w-5xl px-6">
        <DeploymentSavings />
      </div>
    </div>
  )
}
